import '@babel/polyfill';
import 'es6-promise';
import 'isomorphic-fetch';
import Vue from 'vue';
import moment from 'moment';
import Chartist from 'vue-chartist';
import 'chartist-plugin-axistitle';

import './plugins/vuetify';
import Cache from '@/plugins/cache';
import i18n from '@/plugins/i18n';
import App from './App.vue';
import router from './router';
import store from './store/store';
import './registerServiceWorker';
import '@/styles/main.styl';
import '@/components/ApiError';

Vue.use(Chartist);

moment.locale('nl');

Vue.use(Cache, { store });

Vue.config.productionTip = false;

async function start() {
  await fetch('/settings.json')
    .then(res => res.json())
    .then(data => store.commit('inject-axios-variables', { baseUrl: data.VUE_APP_API }));

  router.beforeEach((to, from, next) => {
    const { isAdmin, userToken, isAuthenticated } = store.state.account;
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const requiresAdmin = to.matched.find(record => record.meta.requiresAdmin);

    if (requiresAuth && !isAuthenticated) {
      next(isAdmin ? '/inloggen/admin' : 'inloggen');
    } else if (isAuthenticated && requiresAdmin && !isAdmin) {
      next('/dashboard');
    } else if (
      isAuthenticated
      && isAdmin
      && !userToken
      && !(to.name === 'signInAs' || to.name === 'signInAdmin' || to.name === 'signIn')
    ) {
      next('/inloggen/als');
    } else {
      next();
    }
  });

  const init = () => new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
  }).$mount('#app');

  store.dispatch('account/init').then(init, () => {
    setTimeout(() => store.dispatch('account/signOut'), 1);
    init();
  });
}
start();
